import type { SVGProps } from "react";

export const NoAutomationIllustration = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="110"
      fill="none"
      viewBox="0 0 80 110"
      {...props}
    >
      <path
        fill="#0648FF"
        d="M40 25V40L60 20 40 0V15C17.9 15 0 32.9 0 55c0 7.85 2.3 15.15 6.2 21.3l7.3-7.3C11.25 64.85 10 60.05 10 55c0-16.55 13.45-30 30-30zM73.8 33.7l-7.3 7.3c2.2 4.2 3.5 8.95 3.5 14 0 16.55-13.45 30-30 30V70L20 90l20 20v-15c22.1 0 40-17.9 40-40 0-7.85-2.3-15.15-6.2-21.3z"
      />
      <defs>
        <clipPath id="clip0_844_11930">
          <path
            fill="#fff"
            d="M0 0H120V120H0z"
            transform="translate(97 57)"
          ></path>
        </clipPath>
      </defs>
    </svg>
  );
};
